import { Link } from "react-router-dom";

const SuccessPage  = () => {
    return (
      <div className="py-10 bg-white dark:bg-dark">
        <div className="container">
          <div className="border-green shadow-1 dark:bg-dark-2 flex w-full rounded-lg border-l-[6px] border-[#ff9906] bg-white px-7 py-8 md:p-9">
            <div className="bg-green/10 mr-5 flex h-[34px] w-full max-w-[34px] items-center justify-center rounded-md">
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                {/* SVG Path */}
              </svg>
            </div>
            <div className="w-full">
              <h5 className="mb-3 text-lg font-semibold text-dark dark:text-white">
                Congrats! 🎉 Your Profile is Created Successfully
              </h5>
              <p className="mb-6 text-base leading-relaxed text-body-color dark:text-dark-6">
                Your application has been submitted 🎯.
              </p>
              <p className="mb-4 text-base leading-relaxed text-body-color dark:text-dark-6">
                Thank you for taking the time to apply. We appreciate your interest in joining our team and are excited to review your application!
                Due to the high volume of applications we receive, our team carefully reviews each one to ensure the best fit for our open positions. This process can take some time, so we appreciate your patience as we work through the submissions.
              </p>
              <p className="mb-4 text-base leading-relaxed text-body-color dark:text-dark-6">
                If your skills and experience align with our requirements, we will reach out to you soon to discuss the next steps. In the meantime, please feel free to explore our website for more information about our company, values, and mission.
              </p>
              <p className="mb-4 text-base leading-relaxed text-body-color dark:text-dark-6">
                🚀 Company Website: <a href="#" className="text-green hover:text-green-dark" target="_blank" rel="noopener noreferrer">Hazer Globals</a>
              </p>
              <p className="text-base leading-relaxed text-body-color dark:text-dark-6">
                Thank you again for your interest in joining us – we look forward to the possibility of working together!
              </p>
                <br />
                    <span className='mt-6'>📌 Note: <small>You can check your status of your submitted application but you have to sign up! <br/> for that to keep track all of your applications and their status. Thanks!</small></span>
                    <br/>
                    <div className='bg-gray-200 rounded-tr-3xl rounded-bl-3xl inline-block border-r-[4px] border-l-[4px] border-[#ff9906] p-4 mb-4 mt-4'> 
                        <strong> Best regards, </strong>
                        <br /> <small> The Hazer Global Recruitment Team </small>
                    </div>
                <div className="flex mt-8">
                <Link to="/dashboard" className="inline-block mr-6 text-sm font-medium hover:text-[#ff9706e5] text-green hover:text-green-dark">
                    View Status
                </Link>
                <Link to="/career" className="text-sm font-medium text-dark hover:text-[#ff9706e5] dark:text-dark-6">
                    Go Back to Job Listings
                </Link>
                </div>
            </div>
          </div>
        </div>
      </div>
    );
};

export default SuccessPage 